export const ledOffersQueryKeys = {
  all: ['led-offers'] as const,
  bundledExperiences: () => [...ledOffersQueryKeys.all, 'bundled-experiences'] as const,
  bundledExperiencesByDealOption: (dealOptionId: string) =>
    [...ledOffersQueryKeys.bundledExperiences(), dealOptionId] as const,
};
